import "./scss/main.scss";

import React from "react";
import ReactDOM from "react-dom";
import { PersistGate } from "zustand-persist";

import PaginatedSolutions from "./components/PaginatedSolutions";
import Filters from "./components/Filters";

/**
 * The overview for the solutions including filtering.
 *
 * @author    Anian Weber <a.weber@techdivision.com>
 * @copyright 2021 TechDivision GmbH <info@techdivision.com>
 */

const NcSolutionsApp = () => (
  <PersistGate>
    <div className="solutions__overview row">
      <Filters className="col-md-4" />
      <PaginatedSolutions className="col-md-8" />
    </div>
  </PersistGate>
);

ReactDOM.render(
  <NcSolutionsApp />,
  document.querySelector("#nc-solutions__react-container")
);
